import { render, staticRenderFns } from "./mainpay.vue?vue&type=template&id=2cf7924d&"
import script from "./mainpay.vue?vue&type=script&lang=js&"
export * from "./mainpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports